import * as docudocumentationChangeSeverity from 'constants/enums/documentationChangeSeverity'

export default {
  [docudocumentationChangeSeverity.BIG]: 'Velká závažnost',
  [docudocumentationChangeSeverity.MEDIUM]: 'Střední závažnost',
  [docudocumentationChangeSeverity.NONE]: 'Žádná závažnost',
}
